<template>
  <div class="p-destinationMenu" :class="{
    'is-open': isOpen
  }">
    <ul class="p-destinationMenu__list">
      <li v-for="destination in destinations" class="u-fade">
        <router-link :to="`/destination/${destination.post_name}`">
          <figure class="p-destinationMenu__item">
            <img :src="destination.acf.main_image.url" alt="">
            <figcaption>{{ destination.acf.dest_name }}</figcaption>
          </figure>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  /**
   * Modules
   */
  import { mapGetters } from 'vuex'

  /**
   * Share Partial
   */

  export default {
    name: 'destination-menu',
    data() {
      return {
        destinations: [],
      }
    },
    computed: {
      ...mapGetters({
        'isOpen': 'menu/isOpen',
        'getInfo': 'route/getInfo',
      })
    },
    mounted() {
      this.destinations = this.getInfo().destination_list;
    }
  }
</script>



// WEBPACK FOOTER //
// src/partial/destination-menu.vue